let localhost = "http://localhost:8080" + "/api/v1"; //local server
const baseUrl = process.env.REACT_APP_SKALEBOT_SERVER + "/api/v1";

export default baseUrl;
